import { render, staticRenderFns } from "./index.vue?vue&type=template&id=298ebe29&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=298ebe29&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298ebe29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('298ebe29')) {
      api.createRecord('298ebe29', component.options)
    } else {
      api.reload('298ebe29', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=298ebe29&scoped=true", function () {
      api.rerender('298ebe29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/coreProduct/index.vue"
export default component.exports